// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useState, useRef } from 'react';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Grid,
  Stack,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSetSnackBar } from '../../../store/Snackbar.state';
import { Loading } from '../../atoms';
import { useAddProductWithExcel } from '../../../hooks';
import GetAppIcon from '@mui/icons-material/GetApp';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

export const AddProductWithExcel = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const setSnackbar = useSetSnackBar();

  const FileUpload = () => {
    const [responseData, setResponseData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(null);
    const [uploadCompleted, setUploadCompleted] = useState(false);
    const [uploadSuccessful, setUploadSuccessful] = useState(false);
    const { mutate: productExcelUpload } = useAddProductWithExcel();

    const checkFileExtension = (file) => {
      const acceptedExtension = 'xlsx';
      const currentExtension = file.name.split('.').pop();
      return currentExtension === acceptedExtension;
    };

    const fileInput = useRef();

    const handleFileChange = (e) => {
      const selectedFile = e.target.files[0];
      if (selectedFile) {
        if (checkFileExtension(selectedFile)) {
          setFile(selectedFile);
          setUploadCompleted(false);
        } else {
          setFile(null);
          fileInput.current.value = '';
          setSnackbar({
            severity: "error",
            isOpen: true,
            description: "Lütfen .xlsx formatında dosya yükleyiniz",
          });
        }
      }
    };

    const handleSubmit = async () => {
      if (!file) return;

      setLoading(true);

      const formData = new FormData();
      formData.append('files', file);

      productExcelUpload(formData, {
        onSuccess: (data) => {
          setLoading(false);
          setUploadCompleted(true);
          if (data.isSuccess) {
            setSnackbar({
              severity: "success",
              isOpen: true,
              description: "Ürün dosyası başarıyla yüklendi",
            });
            setUploadSuccessful(true);
          } else {
            setSnackbar({
              severity: "error",
              isOpen: true,
              description: data.message || "Dosya yüklenirken bir hata oluştu",
            });
          }
        },
        onError: (error) => {
          setLoading(false);
          setSnackbar({
            severity: "error",
            isOpen: true,
            description: "İşlem sırasında bir hata oluştu",
          });
        },
      });
    };

    return (
      <>
        <Box sx={{ width: '100%' }}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <TextField
                variant="outlined"
                fullWidth
                type="file"
                onChange={handleFileChange}
                InputLabelProps={{
                  shrink: true,
                }}
                inputRef={fileInput}
                sx={{ height: '56px' }}
              />
            </Grid>
            <Grid item xs={4}>
              <Button
                variant="contained"
                color="primary"
                disabled={!file || loading}
                onClick={handleSubmit}
                fullWidth
                sx={{ height: '55px' }}
              >
                Yükle
              </Button>
            </Grid>
          </Grid>
        </Box>

        {uploadCompleted && (
          uploadSuccessful ? (
            <Card sx={{ minWidth: '100%', minHeight: 100, marginTop: 4, boxShadow: 2, borderRadius: 3 }}>
              <CardContent>
                <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                  <CheckCircleIcon color="success" fontSize="large" />
                  <Typography variant="h5" style={{ color: theme.palette.success.main, fontWeight: 'bold' }}>
                    Ürün Dosyası Başarıyla Yüklendi
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          ) : (
            <Card sx={{ minWidth: '100%', minHeight: 100, marginTop: 4, boxShadow: 2, borderRadius: 3 }}>
              <CardContent>
                <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                  <ErrorIcon color="error" fontSize="large" />
                  <Typography variant="h5" style={{ color: theme.palette.error.main, fontWeight: 'bold' }}>
                    Dosya Yüklenirken Bir Hata Oluştu
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          )
        )}

        {responseData?.data && (
          <Card sx={{ minWidth: 275, marginTop: 4, boxShadow: 2, borderRadius: 3 }}>
            <CardContent>
              <Typography variant="h3" component="div" color="primary" gutterBottom>
                İşlem Bilgileri
              </Typography>
              <Typography variant="h5" gutterBottom>
                Toplam Kayıt: {responseData.data?.totalRecord}
              </Typography>
              <Typography variant="h5" gutterBottom>
                Başarılı Kayıt: {responseData?.data?.successRecord}
              </Typography>
              <Typography variant="h5" gutterBottom>
                Başarısız Kayıt: {responseData?.data?.failRecord}
              </Typography>
              <Typography variant="h5" gutterBottom>
                Hata Mesajları:
              </Typography>
              {responseData && responseData.data.errorMessages ? (
                <div>
                  {responseData.data.errorMessages.map((error, index) => (
                    <Typography key={index} variant="body2" color="error" gutterBottom>
                      {error}
                    </Typography>
                  ))}
                </div>
              ) : (
                <Box display="flex" alignItems="center" gap={1}>
                  <CheckCircleIcon color="success" fontSize="large" />
                  <Typography variant="h5" style={{ color: theme.palette.success.main }}>
                    Hata bulunmadı
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        )}
      </>
    );
  };

  const DownloadButton = () => {
    const fileURL = "/files/toplu-urun-yukleme-ornek.xlsx";

    return (
      <a href={fileURL} download style={{ textDecoration: 'none' }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<GetAppIcon />}
          sx={{ height: '55px', width: '100%' }}
        >
          ÜRÜN YÜKLEME DOSYASINI İNDİR
        </Button>
      </a>
    );
  };

  const handleBack = () => navigate("/vuk-507/products");

  return (
    <>
      <Stack flex={1} justifyContent="space-between">
        <Stack flex={1} p={2}>
          <Stack spacing={4}>
            <Typography variant="h4" component="h1" gutterBottom>
              Excel İle Ürün Ekle
            </Typography>

            <Stack spacing={3}>
              <Stack
                spacing={3}
                width={isDesktop ? 800 : "auto"}
                direction="column"
              >
                <Card sx={{ padding: 2 }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      1. Örnek Excel Dosyasını İndirin
                    </Typography>
                    <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
                      Aşağıdaki butona tıklayarak örnek Excel dosyasını indirin ve gerekli ürün bilgilerini doldurun.
                    </Typography>
                    <DownloadButton />
                  </CardContent>
                </Card>

                <Card sx={{ padding: 2 }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      2. Doldurduğunuz Excel Dosyasını Yükleyin
                    </Typography>
                    <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
                      Ürün bilgilerini doldurduğunuz Excel dosyasını seçin ve yükleyin.
                    </Typography>
                    <FileUpload />
                  </CardContent>
                </Card>
              </Stack>
            </Stack>
          </Stack>
        </Stack>

        <Stack
          borderTop="1px solid #E6E9ED"
          py={2}
          pr={2}
          direction="row"
          justifyContent="flex-end"
        >
          <Button onClick={handleBack} sx={{ mx: 2 }}>
            İptal
          </Button>
        </Stack>
      </Stack>
    </>
  );
};
